const SubText = ({ subTitle, subText }) => (
  <p className='sub-info'>
    <span className='sub-title'>{subTitle}: </span>
    {subText}
  </p>
);

export default SubText;
